import { Stack } from 'expo-router';
import { useLayoutSwitcher } from '@/features/global/hooks/useLayoutSwitcher';

export default function Layout() {
  useLayoutSwitcher();
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="(overview)" />
      <Stack.Screen name="chat" />
      <Stack.Screen name="settings" />
      <Stack.Screen name="meals" />
      <Stack.Screen name="profile/index" />
      <Stack.Screen name="workouts" />
    </Stack>
  );
}
